import BulkActionsConfirmActionStepInlineConfirmation from "components/BulkActions/ConfirmActionStep/InlineConfirmation";

import { StackRolesBulkActionsConfirmActionStepProps } from "../types";

type StackRolesBulkActionsConfirmActionStepDefaultProps =
  StackRolesBulkActionsConfirmActionStepProps;

const StackRolesBulkActionsConfirmActionStepDefault = ({
  action,
  bulkActionsVariant,
  onConfirm,
  onCancel,
  customConfirmationMessage,
}: StackRolesBulkActionsConfirmActionStepDefaultProps) => {
  return (
    <BulkActionsConfirmActionStepInlineConfirmation
      variant={bulkActionsVariant}
      actionLabel={action.title.toLowerCase()}
      onConfirm={() =>
        onConfirm(null, {
          view: bulkActionsVariant,
          metadata: {},
        })
      }
      onCancel={onCancel}
      customConfirmationMessage={customConfirmationMessage}
    />
  );
};

export default StackRolesBulkActionsConfirmActionStepDefault;
